import { render, staticRenderFns } from "./inputAutoAnswers.vue?vue&type=template&id=0c9f8dea&scoped=true&"
import script from "./inputAutoAnswers.vue?vue&type=script&lang=js&"
export * from "./inputAutoAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f8dea",
  null
  
)

export default component.exports